import api from './axios';

// 가맹문의(FR) + 본부지원(BR) 공용 신청 등록
// body: { inquiryType, name, phone, email, hopeSidoCd1, hopeSggCd1, hopeSidoCd2, hopeSggCd2, content, privacyAgree }
// body 키 이름은 백엔드 InquiryCreateRequest 필드명과 동일하게 맞춰야 한다.
// 희망지역은 2026-08-04부터 자유텍스트(region1/region2)가 아니라 시도/시군구 코드
// (CODE_MST CD_GROUP=REGION, BR_MST/FR_MST와 동일 코드 체계)로 받는다. 드롭다운 목록은
// regionService.getSidoList/getSggList로 조회한다.
export async function postInquiry(body) {
  const { data } = await api.post('/inquiries', body);
  return data;
}
